import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoPlayer from './components/VideoPlayer';
import Resume from './components/Resume';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <VideoPlayer />
      <Resume />
      <Footer />
    </div>
  );
}

export default App;
